/**
* DevExpress Dashboard (data-item-container.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { getCustomPropertiesSerializationInfo } from '../custom-properties/_custom-properties-utils';
import { TypedSerializableModel } from '../serializable-model';
export class DataItemContainer extends TypedSerializableModel {
    getInfo() {
        return this._getInfoCore().concat(getCustomPropertiesSerializationInfo(this));
    }
    grabFrom(dataItemContainer) {
        this.name(dataItemContainer.name());
    }
    _getContainerType() {
        return this.itemType();
    }
}
